import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=4cf8713c&"
import script from "./Id.vue?vue&type=script&lang=ts&"
export * from "./Id.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports